import React, { useMemo } from 'react';
import { formatTime, getStatusV } from './components/Helpers';
import { QUESTION_TYPES } from '../../common/constants';
import avatar from '../../assets/images/avatar.svg';
import MaleAvatar from '../../assets/images/MaleAvatar.svg';

const escapeHtml = (unsafe) =>
    unsafe
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

const GeneralQuestion = ({ questions, image }) => (
    <div className="ques-ans-wrapper">
        <div className="screening_general_question soft-skills-span">General Questions</div>
        {questions.map((itm, index) => (
            <div className="break-stop" key={index}>
                <div className="question-container question-container-radius">
                    <pre
                        className="question-sub-panel screening_question_sub_panel"
                        style={{ whiteSpace: 'pre-wrap', margin: 0 }}
                    >
                        <code dangerouslySetInnerHTML={{ __html: `${index + 1}. ${escapeHtml(itm.question)}` }} />
                    </pre>
                </div>
                <pre className="ans font-style-soft-skill" style={{ whiteSpace: 'pre-wrap' }}>
                    <p style={{ fontWeight: 600 }}>Transcript:</p>
                    <code
                        dangerouslySetInnerHTML={{ __html: escapeHtml(itm?.answer || "The candidate didn't answer.") }}
                    />
                </pre>
                <div className="conversation-container">
                    {itm?.followUpQuestions?.map((ques, index) => (
                        <div key={index} className="conversation font-style-soft-skill">
                            <div>
                                <div className="profile-img-div-conversation-left">
                                    <img className="profile-img-logo-conversation" src={avatar} alt="Logo" />
                                </div>
                                <div className="conversation-question">
                                    <strong>IncBot</strong>
                                    <p>{ques?.question}</p>
                                </div>
                            </div>
                            <div style={{ position: 'relative' }}>
                                <div className="conversation-transcript">
                                    <strong>Transcript</strong>
                                    <p>{ques?.answer || "The candidate didn't answer."}</p>
                                </div>
                                <div className="profile-img-div-conversation-right">
                                    <img
                                        className="profile-img-logo-conversation"
                                        src={image || MaleAvatar}
                                        alt="Logo"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ))}
    </div>
);

const CustomQuestion = ({ questions, image }) => (
    <div className="ques-ans-wrapper">
        <div className="screening_general_question soft-skills-span">Specific Questions</div>
        {questions.map((itm, index) => (
            <div className="break-stop" key={index}>
                <div className="question-container question-container-radius">
                    <pre
                        className="question-sub-panel screening_question_sub_panel"
                        style={{ whiteSpace: 'pre-wrap', margin: 0 }}
                    >
                        <code dangerouslySetInnerHTML={{ __html: `${index + 1}. ${escapeHtml(itm.question)}` }} />
                    </pre>
                    <div
                        className={`graph-descp-comment graph-status question-sub-panel ${
                            getStatusV(itm?.followUpRating?.rating || itm?.rating)?.color
                        }`}
                    >
                        ({getStatusV(itm?.followUpRating?.rating || itm?.rating)?.title.substring(0, 21)})
                    </div>
                </div>
                <pre className="ans font-style-soft-skill" style={{ whiteSpace: 'pre-wrap' }}>
                    <p style={{ fontWeight: 600 }}>Transcript:</p>
                    <code
                        dangerouslySetInnerHTML={{ __html: escapeHtml(itm?.answer || "The candidate didn't answer.") }}
                    />
                </pre>
                <pre className="ans font-style-soft-skill" style={{ whiteSpace: 'pre-wrap', padding: 0 }}>
                    <div className="coding-comment">
                        <div className="coding-feedback-div">
                            <div style={{ fontWeight: 600 }}>AI Comment:</div>
                        </div>
                        <code dangerouslySetInnerHTML={{ __html: escapeHtml(itm?.ratingReason ?? 'Not Available') }} />
                    </div>
                </pre>
                <div className="conversation-container">
                    {itm?.followUpQuestions?.map((ques, index) => (
                        <div key={index} className="conversation font-style-soft-skill">
                            <div>
                                <div className="profile-img-div-conversation-left">
                                    <img className="profile-img-logo-conversation" src={avatar} alt="Logo" />
                                </div>
                                <div className="conversation-question">
                                    <strong>IncBot</strong>
                                    <p>{ques?.question}</p>
                                </div>
                            </div>
                            <div style={{ position: 'relative' }}>
                                <div className="conversation-tech-div">
                                    <div className="conversation-transcript-tech">
                                        <strong>Transcript</strong>
                                        <p>{ques?.answer || "The candidate didn't answer."}</p>
                                    </div>
                                    <div className="conversation-ai-comment">
                                        <strong>AI Comment</strong>
                                        <p>{ques?.ratingReason || 'Not Available'}</p>
                                    </div>
                                </div>
                                <div className="profile-img-div-conversation-right">
                                    <img
                                        className="profile-img-logo-conversation"
                                        src={image || MaleAvatar}
                                        alt="Logo"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ))}
    </div>
);

const CodingQuestion = ({ questions }) => (
    <div className="ques-ans-wrapper">
        <div className="screening_general_question soft-skills-span">Coding Questions</div>
        {questions.map((itm, index) => (
            <div className="break-stop" key={index}>
                <div className="question-container question-container-radius">
                    <pre
                        className="question-sub-panel screening_question_sub_panel"
                        style={{ whiteSpace: 'pre-wrap', margin: 0 }}
                    >
                        <code dangerouslySetInnerHTML={{ __html: `${index + 1}. ${escapeHtml(itm.question)}` }} />
                    </pre>
                    <div className="question-sub-panel time-taken">Time Taken: {formatTime(itm?.timeTaken)}</div>
                    <div
                        className={`graph-descp-comment graph-status question-sub-panel ${
                            getStatusV(itm.rating)?.color
                        }`}
                    >
                        ({getStatusV(itm.rating)?.title.substring(0, 21)})
                    </div>
                </div>
                <pre className="ans font-style-soft-skill" style={{ whiteSpace: 'pre-wrap', padding: 0 }}>
                    <div className="coding-comment">
                        <div className="coding-feedback-div">
                            <div style={{ fontWeight: 600 }}>
                                AI Comment:{' '}
                                {itm?.codingEvaluation?.language ? `Language(${itm?.codingEvaluation?.language})` : ''}
                            </div>
                            <div className="coding-feedback-container">
                                {itm?.codingEvaluation?.languageCode === 82 && (
                                    <div className="coding-feedback">
                                        <span className="coding-feedback-status">Code Correctness:</span>
                                        <span
                                            className={`coding-feedback-value ${
                                                getStatusV(itm?.codingEvaluation?.codeCorrectness)?.color
                                            }`}
                                        >
                                            {itm?.codingEvaluation?.codeCorrectness ?? 0}/10
                                        </span>
                                    </div>
                                )}
                                <div className="coding-feedback">
                                    <span className="coding-feedback-status">Code Quality:</span>
                                    <span
                                        className={`coding-feedback-value ${
                                            getStatusV(itm?.codingEvaluation?.codeQuality)?.color
                                        }`}
                                    >
                                        {itm?.codingEvaluation?.codeQuality ?? 0}/10
                                    </span>
                                </div>
                                <div className="coding-feedback">
                                    <span className="coding-feedback-status">Code Optimisation:</span>
                                    <span
                                        className={`coding-feedback-value ${
                                            getStatusV(itm?.codingEvaluation?.codeOptimization)?.color
                                        }`}
                                    >
                                        {itm?.codingEvaluation?.codeOptimization ?? 0}/10
                                    </span>
                                </div>
                                {itm?.codingEvaluation?.totalTestCases && (
                                    <div className="coding-feedback">
                                        <span className="coding-feedback-status">Test Cases Passed:</span>
                                        <span className="coding-feedback-value coding-blue">
                                            {itm?.codingEvaluation?.testCasesPassed || 0}/
                                            {itm?.codingEvaluation?.totalTestCases || 0}
                                        </span>
                                    </div>
                                )}
                                <div className="coding-feedback">
                                    <span className="coding-feedback-status">Overall Coding Score:</span>
                                    <span className={`coding-feedback-value ${getStatusV(itm?.rating)?.color}`}>
                                        {itm?.rating ?? 0}/10
                                    </span>
                                </div>
                            </div>
                        </div>
                        <code dangerouslySetInnerHTML={{ __html: escapeHtml(itm?.ratingReason ?? 'Not Available') }} />
                    </div>
                </pre>
                <pre className="ans font-style-soft-skill coding-answer" style={{ whiteSpace: 'pre-wrap' }}>
                    <p style={{ fontWeight: 600 }}>Code Snippet:</p>
                    <code
                        dangerouslySetInnerHTML={{
                            __html: escapeHtml(itm?.answer?.trim() || "The candidate didn't answer."),
                        }}
                    />
                </pre>
            </div>
        ))}
    </div>
);

export const ScreeningQuestion = ({ data, image }) => {
    const customQuestions = useMemo(() => data?.filter((q) => q.questionType === QUESTION_TYPES.CUSTOM), [data]);
    const codingQuestions = useMemo(() => data?.filter((q) => q.questionType === QUESTION_TYPES.CODING), [data]);
    const generalQuestions = useMemo(() => data?.filter((q) => q.questionType === QUESTION_TYPES.GLOBAL), [data]);

    return (
        <div className="screening-ques-wrapper break-stop">
            <div className="skills-div title_mob_hide">
                <span className="soft-skills-span">Screening Questions</span>
            </div>
            {generalQuestions.length > 0 && <GeneralQuestion questions={generalQuestions} image={image} />}
            {customQuestions.length > 0 && <CustomQuestion questions={customQuestions} image={image} />}
            {codingQuestions.length > 0 && <CodingQuestion questions={codingQuestions} />}
        </div>
    );
};
